import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
  Modal,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./document.css";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import Doc1 from "../../../upload/test.pdf";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Form } from "antd";
import getEventController from "../Controller/getEvent_controller";

const Document = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const [spacing, setSpacing] = React.useState(2);
  const [form] = Form.useForm();
  const [documentCategoriesData, setdocumentCategoriesData] = useState([]);

  // State for managing modal
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [open, setOpen] = useState(false);

  // Sample events array with image and title data
  const documents = [];

  useEffect(() => {
    getEventController
      .getDocumentCategories()
      .then((response) => {
        console.log("API Response:", response); // Debugging log

        if (Array.isArray(response)) {
          // Ensure response is an array
          setdocumentCategoriesData(response);
        } else {
          console.error("API response is not an array:", response);
          setdocumentCategoriesData([]); // Set empty array to prevent .map() errors
        }
      })
      .catch((error) => {
        console.error("Error fetching event categories:", error);
        setdocumentCategoriesData([]); // Handle errors gracefully
      });
  }, []);

  // Handle click to open modal and set the selected document
  const handleOpen = (doc) => {
    setSelectedDocument(doc);
    setOpen(true);
  };

  const handleEventClick = (documentCategoryID, title) => {
    navigate("/document_details", { state: { documentCategoryID, title } }); // Update the state without changing the URL
  };

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="gallery-list">
          {/*Search Bar */}
          <div className="row-1 ">
            <Grid className="sec_grid" container spacing={2}>
              <Grid size={12}>
                <TextField
                  className="searchbar"
                  label="Search"
                  variant="outlined"
                  size="small"
                  slotProps={{
                    input: {
                      endAdornment: (
                        <IconButton
                          type="button"
                          aria-label="search"
                          size="small"
                        >
                          <SearchIcon />
                        </IconButton>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </div>
          {/*Documents Grid*/}
          <div className="document-row">
            <Grid container spacing={2} sx={{ justifyContent: "center" }}>
              {documents.map((doc, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={index}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Paper
                    sx={(theme) => ({
                      display: "flex",
                      height: 300,
                      width: 250,
                      marginTop: "20px",
                      backgroundColor: "#fff",
                      ...theme.applyStyles("dark", {
                        backgroundColor: "#1A2027",
                      }),
                      boxShadow: 5,
                      justifyContent: "center",
                      alignItems: "center",
                    })}
                    onClick={() => handleOpen(doc)}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        fontSize: "12px",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      <img
                        src={doc.imgSrc}
                        alt={doc.title}
                        className="upcoming-event-icon"
                      />
                      <span>{doc.title}</span>
                    </div>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      ) : (
        <div className="gallery-list">
          <div className="gallery-title">Resources</div>
          {/*Search Bar */}
          {/*Documents Grid*/}
          <div className="document-row">
            <Grid
              container
              spacing={2}
              sx={{ justifyContent: "center", margin: "10px" }}
            >
              {documentCategoriesData.map((event, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Form form={form} component={false}>
                    <Paper
                      sx={(theme) => ({
                        display: "flex",
                        flexDirection: "column", // Stack items vertically
                        alignItems: "center", // Center content
                        height: "250px",
                        width: "450px",
                        marginTop: "20px",
                        backgroundColor: "#fff",
                        ...theme.applyStyles("dark", {
                          backgroundColor: "#1A2027",
                        }),
                        boxShadow: 5,
                        justifyContent: "center", // Center content inside
                        border: "2px solid #b24743",
                        borderRadius: "15px",
                        cursor: "pointer",
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": {
                          transform: "scale(1.03)",
                          boxShadow: 10,
                        },
                      })}
                      onClick={() =>
                        handleEventClick(event.document_categoryID, event.label)
                      }
                    >
                      <div
                        className="col-md-12"
                        style={{
                          display: "flex",
                          flexDirection: "column", // Stack items vertically
                          alignItems: "center",
                          padding: "10px",
                          textAlign: "center",
                          height: "100px",
                        }}
                        id={event.id}
                      >
                        {/* Event Category Title */}
                        <span className="event-category-title">
                          {event.label}
                        </span>
                      </div>
                      {/* Button Wrapper (Separate div for better positioning) */}
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            width: "80%", // Make button longer
                            padding: "10px",
                            backgroundColor: "#b24743",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "bold",
                            transition: "background-color 0.3s",
                          }}
                        >
                          View More
                        </button>
                      </div>
                    </Paper>
                  </Form>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Document;
